import React, {useEffect} from 'react';
import FluxerLogo from "../images/Group 220.svg";
import ErrorIcon from "../images/errorIcon.png";
import {REQUIRED_FIELD} from "../constants/Messages";
import {useDispatch, useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";
import {useForm} from "react-hook-form";
import {login2Fa} from "../redux-store/auth";
import {get2FaStatus, getLoginPassedStatus, getUserInfo, isAuthenticated} from "../redux-store/selectors";

const TwoFaLoginComponent = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const userInfo = useSelector(getUserInfo);
    const loginPassed = useSelector(getLoginPassedStatus);
    const is2FA = useSelector(get2FaStatus);
    const authenticated = useSelector(isAuthenticated);

    const {
        register,
        handleSubmit,
        formState: {errors},
    } = useForm();

    useEffect(()=>{
        if(!loginPassed || !is2FA)
            navigate("/login")
    },[]);
    useEffect(()=>{
        if(authenticated)
            navigate("/");
    },[authenticated])
    const onsubmit = data =>{

        data.username = userInfo.username;
        dispatch(login2Fa({data,token:userInfo.jwttoken}));
    }
    return (
        <div className="login-background">
            <div className="container position-absolute card-top top-50 start-50 translate-middle">
                <div className="row justify-content-sm-center">
                    <div className="col-xl-4 col-lg-5 col-md-6 col-sm-10 login-card">
                        <div className="card">
                            <div className="card-body p-3">
                                <h1 className="fs-4 card-title fw-bold mb-5 text-center text-white pt-2"><img
                                    src={FluxerLogo}/></h1>
                                <form onSubmit={handleSubmit(onsubmit)}>
                                    <div className="mb-4">
                                        <label className="mb-2 text-white login-label" htmlFor="username">Kod</label>
                                        <input type="text"
                                               className="form-control"
                                               name={"username"}
                                               {...register("code", {required: true})}/>
                                        {errors.code && (
                                            <span className="loggin-error"><img
                                                src={ErrorIcon}/> {REQUIRED_FIELD}</span>
                                        )}
                                    </div>
                                    <div className="d-flex align-items-center">
                                        <button type="submit" className="btn btn-main w-100">
                                            Potvrdi
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TwoFaLoginComponent;
